









































































































import Vue from "vue";
import Component from "vue-class-component";
import { CommunityInterface } from "@/types";
import User from "@/User";

interface CommunityForm {
  name: string;
  tag: string;
  url: string;
  logo: string;
  description: string;
  mainCommunity: boolean;
}

@Component({
  metaInfo: {
    title: "Community Management – Newfound Pioneer Corps Arma 3",
    meta: [
      { vmid: "description", name: "description", content: "Manage communities affiliated with the Newfound Pioneer Corps." },
      { vmid: "og:title", property: "og:title", content: "Community Management – Newfound Pioneer Corps Arma 3" },
      { vmid: "og:description", property: "og:description", content: "Manage communities affiliated with the Newfound Pioneer Corps." },
      { vmid: "og:url", property: "og:url", content: "https://arma.npcs.games/community-management" },
    ],
  },
})
export default class CommunityManagement extends Vue {
  private communities: CommunityInterface[] = [];
  private loading: boolean = true;
  private saving: boolean = false;
  private dialog: boolean = false;
  private deleteDialog: boolean = false;
  private isEditing: boolean = false;
  private editingId: number | null = null;
  private deleteTarget: CommunityInterface | null = null;

  private form: CommunityForm = {
    name: "",
    tag: "",
    url: "",
    logo: "",
    description: "",
    mainCommunity: false,
  };

  public async mounted() {
    if (!(await User.isModerator())) {
      this.$router.push("/");
      return;
    }
    await this.loadCommunities();
  }

  public openCreateDialog() {
    this.isEditing = false;
    this.editingId = null;
    this.form = { name: "", tag: "", url: "", logo: "", description: "", mainCommunity: false };
    this.dialog = true;
  }

  public openEditDialog(community: CommunityInterface) {
    this.isEditing = true;
    this.editingId = community.id;
    this.form = {
      name: community.name,
      tag: community.tag,
      url: community.url || "",
      logo: community.logo || "",
      description: community.description || "",
      mainCommunity: community.mainCommunity,
    };
    this.dialog = true;
  }

  public confirmDelete(community: CommunityInterface) {
    this.deleteTarget = community;
    this.deleteDialog = true;
  }

  public async save() {
    const formRef = this.$refs.form as any;
    if (!formRef.validate()) { return; }
    this.saving = true;
    try {
      const payload = {
        name: this.form.name,
        tag: this.form.tag,
        url: this.form.url || null,
        logo: this.form.logo || null,
        description: this.form.description || null,
        mainCommunity: this.form.mainCommunity,
      };
      if (this.isEditing && this.editingId !== null) {
        await this.axios.patch(`/community/communities/${this.editingId}`, payload);
      } else {
        await this.axios.post("/community/communities", payload);
      }
      this.dialog = false;
      await this.loadCommunities();
    } catch {
      this.$store.dispatch("showErrorSnackbar", "Failed to save community.");
    } finally {
      this.saving = false;
    }
  }

  public async deleteCommunity() {
    if (!this.deleteTarget) { return; }
    this.saving = true;
    try {
      await this.axios.delete(`/community/communities/${this.deleteTarget.id}`);
      this.deleteDialog = false;
      this.deleteTarget = null;
      await this.loadCommunities();
    } catch {
      this.$store.dispatch("showErrorSnackbar", "Failed to delete community.");
    } finally {
      this.saving = false;
    }
  }

  private async loadCommunities() {
    this.loading = true;
    try {
      const response = await this.axios.get("/community/communities");
      this.communities = response.data;
    } catch {
      this.$store.dispatch("showErrorSnackbar", "Failed to load communities.");
    } finally {
      this.loading = false;
    }
  }
}
